import { SelectionModel } from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MaterialManagerCoreService {
    public areItemsProcessing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public selection = new SelectionModel<any>(true, []);
    constructor() {}
}
